import React, { useState, useEffect, useRef } from 'react';
import {
  Button,
  Input,
  Tooltip,
  Whisper,
  Stack,
  IconButton,
  InputGroup,
  Form,
  Message,
  Table,
  SelectPicker,
  toaster,
  InputNumber
} from 'rsuite';
import CheckIcon from '@rsuite/icons/Check';
import EditIcon from '@rsuite/icons/Edit';
import CloseIcon from '@rsuite/icons/Close';
import SearchIcon from '@rsuite/icons/Search';
import globalIP from '@/GlobelIP';
import axios from 'axios';
import useTableHeight from '@/components/useTableHeight';
import CheckRoundIcon from '@rsuite/icons/CheckRound';
import WarningRoundIcon from '@rsuite/icons/WarningRound';
import { set } from 'lodash';
import { ReviewPass } from '@rsuite/icons';
import { Popconfirm } from 'antd';

interface RowDataSeason {
  id: string; // or number, depending on your data
  attributes: {
    SeasonName: string;
  };
}
interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}

const SeasonMaster = () => {
  const { Cell } = Table;
  const { tableHeight, tableHeight2 } = useTableHeight();
  const data = ['Continue', 'Discontinue', 'All'].map(item => ({ label: item, value: item }));

  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchDatalabel();
  }, []);
  const fetchDatalabel = async () => {
    try {
      const response = await fetch(`${globalIP}/api/product-labels`);
      const json = await response.json();
      setLabel(json.data);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };

  ////////////////  Function For 9 Start /////////////////
  const [season, setSeason] = useState({
    SeasonName: '',
    dis: 'Continue'
  });

  // Fetch Data from API Start
  const [seasondata, setSeasondata] = useState<RowDataSeason[]>([]);
  const [seasonmeta, setSeasonmeta] = useState<MetaData>();
  const [editedRowIdsSeason, setEditedRowIdsSeason] = useState<string[]>([]);
  const [editedRowIdSeason, setEditedRowIdSeason] = useState<string>('');
  const [editedDataSeason, setEditedDataSeason] = useState<
    Record<string, Partial<RowDataSeason['attributes']>>
  >({});
  const [disSeason, setDisSeason] = useState([]);
  const [selectedBuyerseason, setSelectedBuyerseason] = useState('Continue');
  const handleBuyerChangeseason = value => {
    setSelectedBuyerseason(value);
  };
  const [isLoading9, setIsLoading9] = useState(false);
  useEffect(() => {
    fetchData9();
  }, [selectedBuyerseason]);
  const fetchData9 = async () => {
    if (isLoading9) {
      return;
    }
    setIsLoading9(true);
    let disFilter = '';
    if (selectedBuyerseason.length > 0) {
      disFilter = `&filters[dis][$eq]=${selectedBuyerseason}`;
    }
    if (selectedBuyerseason == 'All') {
      disFilter = '';
    }
    const pageResponse = await fetch(
      `${globalIP}/api/season-masters?populate=*&pagination[page]=1&sort[0]=id${disFilter}`
    );
    const pageJson = await pageResponse.json();
    const allData = [];
    for (let page = 1; page <= pageJson.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${globalIP}/api/season-masters?populate=*&pagination[page]=${page}&sort[0]=id${disFilter}`
      );
      const pageJson = await pageResponse.json();
      allData.push(...pageJson.data);
    }
    const responseformeta = await fetch(
      `${globalIP}/api/season-masters?populate=*&publicationState=preview`
    );
    const jsonmeta = await responseformeta.json();

    const response2 = await fetch(`${globalIP}/api/season-masters`);
    const pageJson2 = await response2.json();
    const allData2 = [];
    for (let page = 1; page <= pageJson2.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${globalIP}/api/season-masters?populate=*&pagination[page]=${page}`
      );
      const pageJson2 = await pageResponse.json();
      allData2.push(...pageJson2.data);
    }
    setDisSeason(allData2);
    setSeasonmeta(jsonmeta.meta);
    setSeasondata(allData);
    setIsLoading9(false);
  };
  const processInputRef = useRef(null);
  const handleEditRowSeason = rowData => {
    setSeason({ ...rowData.attributes });
    setEditedRowIdSeason(rowData.id);
    setEditedRowIdsSeason(prevRowIds => [...prevRowIds, rowData.id]);
    setEditedDataSeason(prevData => ({
      ...prevData,
      [rowData.id]: { ...rowData.attributes }
    }));
    if (processInputRef.current) {
      processInputRef.current.focus();
    }
  };
  const resetSeason = () => {
    setSeason({
      SeasonName: '',
      dis: 'Continue'
    });
  };
  const handleCancelPtech = rowData => {
    resetSeason();
    setEditedRowIdSeason('');
    setEditedRowIdsSeason('');
  };


  const url9 = `${globalIP}/api/season-masters`;
  const submit9 = async e => {
    e.preventDefault(); // Prevent default form submission behavior
    const trimmedSeasonName = season.SeasonName?.trim();
    const specialCharPattern = /[{}\[\];:"'|<,>._?+=*&^%$#@!~`()\\]/
    console.log('trimmedSeasonName', trimmedSeasonName);

    // Validate the season name
    if (trimmedSeasonName === '') {
      toaster.push(
        <Message showIcon type="error">
          Please enter a valid {label[0]?.attributes.Season}.
        </Message>,
        { placement: 'topCenter' }
      );
      return; // Exit if validation fails
    }

    if (specialCharPattern.test(trimmedSeasonName)) {
      toaster.push(
        <Message showIcon type="error">
          {label[0]?.attributes.Season} should not contain special characters.
        </Message>,
        { placement: 'topCenter' }
      );
      return; // Exit if validation fails
    }
    try {
      // Check for existing season name
      const { data: seasonName } = await axios.get(
        `${globalIP}/api/season-masters?filters[SeasonName][$eqi]=${trimmedSeasonName}`
      );

      // const existingSeason = disSeason.find(
      //   item => item.attributes.SeasonName.toLowerCase() === trimmedSeasonName.toLowerCase()
      // );

      if (seasonName.data.length) {
        toaster.push(
          <Message showIcon type="warning">
            {label[0]?.attributes.Season} {trimmedSeasonName} already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return; // Exit if season already exists
      }

      // Create FormData and append season data
      const formData = new FormData();
      formData.append('data', JSON.stringify({ ...season, SeasonName: trimmedSeasonName }));

      // Send the POST request to save the season
      const response = await fetch(url9, {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        await fetchData9(); // Refresh the data
        console.log(season);

        toaster.push(
          <Message showIcon type="success">
            Data saved successfully.
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        console.error('Failed to save data');
        toaster.push(
          <Message showIcon type="error">
            Failed to save {label[0]?.attributes.Season}. Please try again.
          </Message>,
          { placement: 'topCenter' }
        );
      }
    } catch (error) {
      console.error('Error occurred while saving season data', error);
      toaster.push(
        <Message showIcon type="error">
          An error occurred while saving {label[0]?.attributes.Season}. Please try again.
        </Message>,
        { placement: 'topCenter' }
      );
    }

    // Reset the season state
    setSeason({
      SeasonName: '',
      dis: 'Continue'
    });
  };

  //  Fetch Data from API End
  const handleInputChange9 = (inputName, value, index) => {
    setSeason({ ...season, [inputName]: value });
  };
  const handleSeasonc = async (catalogId, mat) => {
    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        ...seasondata,
        dis: 'Continue'
      })
    );
    fetch(`${globalIP}/api/season-masters/${catalogId}`, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        fetchData9();
        toaster.push(
          <Message showIcon type="success">
            {mat} Continue Successfully.
          </Message>,
          { placement: 'topEnd' }
        );
      })
      .catch(error => {
        console.error(error);
      });
  };
  const handleSeasonD = async (catalogId, mat) => {
    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        ...seasondata,
        dis: 'Discontinue'
      })
    );
    fetch(`${globalIP}/api/season-masters/${catalogId}`, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        fetchData9();
        toaster.push(
          <Message showIcon type="success">
            {mat} Discontinue Successfully.
          </Message>,
          { placement: 'topEnd' }
        );
        // Refresh page after 2 seconds (2000 milliseconds)
      })
      .catch(error => {
        console.error(error);
      });
  };

  const handleSaveRowSeason = async (rowId: string) => {
    try {
      // const rowData = seasondata.find(row => row.id === rowId);
      if (!season) {
        console.error('Row data not found.');
        return; // Exit if row data is not found
      }

      const updatedCategoryName = season?.SeasonName?.trim() || '';

      const specialCharPattern = /[{}\[\];:"'|<,>._?+=*&^%$#@!~`()\\]/

      // Validate the updated season name
      if (!updatedCategoryName) {
        toaster.push(
          <Message showIcon type="error">
            Please enter a valid {label[0]?.attributes.Season}.
          </Message>,
          { placement: 'topCenter' }
        );
        return; // Exit if validation fails
      }

      if (specialCharPattern.test(updatedCategoryName)) {
        toaster.push(
          <Message showIcon type="error">
            {label[0]?.attributes.Season} should not contain special characters.
          </Message>,
          { placement: 'topCenter' }
        );
        return; // Exit if validation fails
      }

      const { data: updateSeasion } = await axios.get(
        `${globalIP}/api/season-masters?filters[SeasonName][$eqi]=${updatedCategoryName}&filters[id][$ne]=${editedRowIdSeason}`
      );
      if (updateSeasion.data.length) {
        toaster.push(
          <Message showIcon type="warning">
            {label[0]?.attributes.Season} {updatedCategoryName} already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return; // Stop the function if validation fails
      }
      // Create the updated row data
      // const updatedRowData: RowDataSeason = {
      //   ...rowData,
      //   attributes: {
      //     ...rowData.attributes,
      //     ...editedDataSeason[rowId],
      //     SeasonName: updatedCategoryName
      //   }
      // };

      // Send the PUT request to update the season
      const response = await fetch(`${globalIP}/api/season-masters/${editedRowIdSeason}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ data: { ...season, SeasonName: updatedCategoryName } })
      });

      if (response.ok) {
        // If the API call is successful, update the data
        fetchData9();
        resetSeason('')
        setEditedRowIdSeason('');
        setEditedDataSeason(prevData => ({
          ...prevData,
          [editedRowIdSeason]: { ...season, SeasonName: updatedCategoryName } // Ensure UI updates correctly
        }));
        setEditedRowIdsSeason(prevRowIds => [...new Set([...prevRowIds, editedRowIdSeason])]);

        toaster.push(
          <Message showIcon type="success">
            {label[0]?.attributes.Season} updated successfully.
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        console.error('Failed to save data');
        toaster.push(
          <Message showIcon type="error">
            Failed to save {label[0]?.attributes.Season}. Please try again.
          </Message>,
          { placement: 'topCenter' }
        );
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
      toaster.push(
        <Message showIcon type="error">
          An error occurred while saving {label[0]?.attributes.Season}. Please try again.
        </Message>,
        { placement: 'topCenter' }
      );
    }
  };

  const handleInputChangeSeason = (rowId, fieldName, value) => {
    setEditedDataSeason(prevData => {
      const updatedData = { ...prevData };
      if (!updatedData[rowId]) {
        updatedData[rowId] = { ...seasondata.find(row => row.id === rowId).attributes };
      }
      updatedData[rowId][fieldName] = value;
      return updatedData;
    });
  };
  ////////////////  Function For 9 End /////////////////
  ////////////////  Searching For 9 Start /////////////////
  const [searchQuery9, setSearchQuery9] = useState('');
  const [filterStatus9, setFilteredStatus9] = useState('Continue');
  const handleSearch9 = value => {
    setSearchQuery9(value);
  };
  const [sessionFilterData, setSessionFilterData] = useState([]);

  useEffect(() => {
    const sessionFilterData = seasondata
      .slice()
      .reverse()
      .filter(item => {
        const SeasonName = item.attributes.SeasonName
          ? item.attributes.SeasonName.toLowerCase()
          : '';
        return SeasonName.includes(searchQuery9.toLowerCase());
      });
    setSessionFilterData(sessionFilterData);
  }, [seasondata, filterStatus9, searchQuery9]);
  ////////////////  Searching For 9 End /////////////////
  return (
    <div>
      <>
        <Form.ControlLabel>
          <b>{label[0]?.attributes.Season}</b>
        </Form.ControlLabel>
        <Stack
          justifyContent="space-between"
          style={{ marginBottom: '10px' }}
          className="mstr-panel"
        >
          <Stack spacing={160} className="mstr-panel1">
            <Input
              id="SeasonName"
              name="SeasonName"
              style={{ width: '180%' }}
              autoComplete="off"
              ref={processInputRef}
              value={season && season.SeasonName ? season.SeasonName : ''}
              onChange={value => handleInputChange9('SeasonName', value, 0)}
              onPressEnter={submit9}
            />
            {editedRowIdSeason ? (
              <Button
                appearance="primary"
                color="cyan"
                onClick={handleSaveRowSeason}
                className="mstr-btn"
                style={{ marginLeft: '10px' }}
              >
                Update
              </Button>
            ) : (
              <Button
                appearance="primary"
                color="cyan"
                onClick={submit9}
                className="mstr-btn"
                style={{ marginLeft: '10px' }}
              >
                Add
              </Button>
            )}

          </Stack>
          <Stack className="mstr-search" spacing={5} style={{ marginLeft: '7px' }}>
            <SelectPicker
              data={data}
              placeholder="Status"
              labelKey="label"
              value={selectedBuyerseason}
              onChange={handleBuyerChangeseason}
              searchable={false}
              valueKey="value"
              size="md"
              appearance="default"
              style={{ width: 130 }}
              cleanable={false}
            />
            <InputGroup inside>
              <Input
                placeholder="Search"
                type="text"
                value={searchQuery9}
                onChange={handleSearch9}
              />
              <InputGroup.Addon>
                <SearchIcon />
              </InputGroup.Addon>
            </InputGroup>
          </Stack>
        </Stack>
        <Table
          rowHeight={60}
          data={sessionFilterData}
          height={tableHeight}
          rowKey="id"
          bordered
          cellBordered
          loading={isLoading9}
        >
          <Table.Column width={60} fixed>
            <Table.HeaderCell>
              <b>Sr. No.</b>
            </Table.HeaderCell>
            <Cell>{(_, rowIndex) => +rowIndex + 1}</Cell>
          </Table.Column>

          <Table.Column width={150} flexGrow={1}>
            <Table.HeaderCell>
              <b>{label[0]?.attributes.Season}</b>
            </Table.HeaderCell>
            <Table.Cell>
              {rowData =>
                // editedRowIdsSeason.includes(rowData.id) ? (
                //   <Input
                //     value={editedDataSeason[rowData.id]?.SeasonName || ''}
                //     onChange={value => handleInputChangeSeason(rowData.id, 'SeasonName', value)}
                //   />
                // ) : (
                rowData.attributes.SeasonName
                // )
              }
            </Table.Cell>
          </Table.Column>
          <Table.Column width={90} fixed="right">
            <Table.HeaderCell>
              <b>Action</b>
            </Table.HeaderCell>
            <Table.Cell>
              {rowData =>
                editedRowIdsSeason.includes(rowData.id) ? (
                  <div>
                    {/* <IconButton
                      size="sm"
                      icon={<CheckIcon />}
                      active
                      onClick={() => handleSaveRowSeason(rowData.id)}
                      style={{ marginRight: '10px' }}
                    /> */}
                    <IconButton
                      size="sm"
                      icon={<EditIcon />}
                      active
                      onClick={() => handleEditRowSeason(rowData)}
                      style={{ marginRight: '10px' }}
                    />
                    <IconButton
                      size="sm"
                      icon={<CloseIcon />}
                      active
                      onClick={handleCancelPtech}
                    // onClick={() =>
                    //   setEditedRowIdsSeason(prevRowIds =>
                    //     prevRowIds.filter(id => id !== rowData.id)
                    //   )
                    // }
                    />
                  </div>
                ) : (
                  <div>
                    <IconButton
                      size="sm"
                      icon={<EditIcon />}
                      active
                      onClick={() => handleEditRowSeason(rowData)}
                    />
                    {rowData.attributes.dis === 'Discontinue' ? (
                      <Popconfirm
                        title="Continue Season"
                        description="Are you sure you want to continue this Season?"
                        onConfirm={() => handleSeasonc(rowData.id, rowData.attributes.SeasonName)}
                        // onCancel={cancel}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Whisper speaker={<Tooltip>Continue</Tooltip>}>
                          <IconButton
                            size="sm"
                            icon={<CheckRoundIcon />}
                            active
                            style={{ marginLeft: '10px' }}
                          // onClick={() => handleSeasonc(rowData.id, rowData.attributes.SeasonName)}
                          />
                        </Whisper>
                      </Popconfirm>
                    ) : (
                      <Popconfirm
                        title="Discontinue Season"
                        description="Are you sure you want to discontinue this Season?"
                        onConfirm={() => handleSeasonD(rowData.id, rowData.attributes.SeasonName)}
                        // onCancel={cancel}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Whisper speaker={<Tooltip>Discontinue</Tooltip>}>
                          <IconButton
                            size="sm"
                            icon={<ReviewPass />}
                            active
                            style={{ marginLeft: '10px' }}
                          // onClick={() => handleSeasonD(rowData.id, rowData.attributes.SeasonName)}
                          />
                        </Whisper>
                      </Popconfirm>
                    )}
                  </div>
                )
              }
            </Table.Cell>
          </Table.Column>
        </Table>
        <div>
          <p>
            <small>Total row:{sessionFilterData.length}</small>
          </p>
        </div>
      </>
    </div>
  );
};

export default SeasonMaster;
